import AuthService from "../../utilities/services/auth.service";

import { ModalProvider } from "../../providers/ModalProvider/ModalProvider";

import { ClubSeatWrapper } from "../../components";

export default function CLubSeatPage() {
  const organization = AuthService.getOrg()[0];

  return (
    <ModalProvider>
      <ClubSeatWrapper organization={organization} />
    </ModalProvider>
  );
}
